<template>
  <div
    :class="{ 'br-guide--pop br-guide--active': active }"
    class="br-guide">
    <div
      class="br-guide__trigger js-show-guide-popup"
      @click="toggle">
      <img src="/img/logo/zenvoy-logo-icon.svg">
    </div>
    <div class="br-guide__popup">
      <div class="br-guide__dialog">
        <div class="br-guide__dialog__head">
          <button
            class="button button--icon"
            @click.prevent="toggle">
            <i class="icon icon-e-remove-2"/>
          </button>
          <div class="brand">
            <img src="/img/logo/zenvoy-logo-ai.svg">
          </div>
          <h4>Welcome to Zenvoy!</h4>
          <p>We are happy to assist you. Let us know if you have any questions or need any more information.</p>
          <div class="br-guide__agent">
            <p><strong>Have a question?</strong></p>
            <div class="br-guide__agent__details">
              <div class="avatar">
                <img
                  src="/img/avatars/dennis-chapham.jpg"
                  alt="">
              </div>
              <span class="text">Hello! My name is Dennis, I’m head of Zenvoy’s Enterprise Sales. How can I help you? </span>
            </div>
            <div class="br-guide__agent__attachments">
              <div class="br-guide__agent__attachments__item">
                <div class="br-guide__agent__attachments__filetype">
                  PDF
                </div>
                <a
                  href="/files/Zenvoy_Info_Deck.pdf"
                  target="_blank"
                  download>Zenvoy Products Presentation</a>
                <span class="text">1.3mb</span>
              </div>
              <div class="br-guide__agent__attachments__item">
                <div class="br-guide__agent__attachments__filetype">
                  PDF
                </div>
                <a
                  href="/files/Zenvoy_Brochure.pdf"
                  target="_blank"
                  download>Zenvoy Brochure</a>
                <span class="text">1.5mb</span>
              </div>
            </div>
            <button
              class="button button--small u-border-radius"
              @click.prevent="openCalendly">
              <span class="button__icon">
                <i class="icon icon-wand-11"/>
              </span>
              <span class="button__label">Schedule a quick demo</span>
            </button>
          </div>
        </div>
        <div class="br-guide__dialog__body">
          <a
            v-modal.video-modal
            href=""
            class="br-guide__media-preview">
            <div
              class="br-guide__media-preview__thumbnail">
              <i class="icon icon-triangle-right"/>
            </div>
            <div class="text-group">
              <span class="text text--highlight">What is Zenvoy?</span>
              <span class="text">A quick overview of what we do, and how we do it.</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    active: false,
    progress: 0
  }),
  created () {
    setTimeout(() => {
      this.progress = 78
    }, 200)
  },
  methods: {
    toggle () {
      this.active = !this.active
    },
    openCalendly () {
      window.Calendly.showPopupWidget('https://calendly.com/zenvoy1/demo')
    }
  }
}
</script>
